import React, { useCallback, useRef, useState } from 'react';
import axios from '../../sagas/axios';
import ModalAlert from '../../components/modal/modal_alert';
import ModalLoader from '../../../modal/modal_loader';
import ModalRegisterCreditcard from '../../components/modal/modal_register_creditcard';
import DatePicker, { registerLocale } from "react-datepicker";
import ja from "date-fns/locale/ja";
registerLocale("ja", ja);

const Edit = ({ userfeedId, userfeedsEvent = [], isNew = false, isEventDateDisabled = false, hasPayjp , pointAmount, isPaidVersion, cardEmail }) => {
  const [place, setPlace] = useState(userfeedsEvent.place ? userfeedsEvent.place : '');
  const [eventDate, setEventDate] = useState(userfeedsEvent.event_date ? new Date(userfeedsEvent.event_date) : '');
  const [event, setEvent] = useState([]);
  const [minNumOfPeople, setMinNumOfPeople] = useState(userfeedsEvent.min_num_of_people ? userfeedsEvent.min_num_of_people : 2);
  const [capacity, setCapacity] = useState(userfeedsEvent.capacity ? userfeedsEvent.capacity : '');
  const [hasCredit, setHasCredit] = useState(hasPayjp);
  const [isPayedByAmazon, setIsPayedByAmazon] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const successRef = useRef(null);
  const errorRef = useRef(null);
  const loaderRef = useRef(null);
  const modalAlertCreditErr = useRef(null);
  const modalCreditcardRef = useRef(null);
  const point = useState(pointAmount);

  const now = new Date();
  const minTime = new Date(now.getTime() + 6 * 60 * 60 * 1000); // イベントは6時間後から作成可能
  // const minTime = new Date(now); // イベントは現在時刻以降作成可能
  const maxTime = new Date(now);
  maxTime.setHours(23);
  maxTime.setMinutes(50);
  const startTime = new Date(now);
  startTime.setHours(0, 0, 0, 0);
  const maxDate = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000); // 1 ヶ月後までの日付を選択可能にする

  const onSubmit = useCallback(
    (e) => {
      if (isProcessing) return;

      setIsProcessing(true);

      e.preventDefault();
      if (isNew && !isPayedByAmazon && !hasCredit) {
        modalAlertCreditErr.current.openModal();
        return;
      }

      loaderRef.current.openModal();

      const body = JSON.stringify({
        event_date: eventDate,
        place: place,
        capacity: capacity,
        min_num_of_people: minNumOfPeople,
        is_payed_by_amazon: isPayedByAmazon,
      });
      try {
        const endpoint = isNew
          ? `/api/userfeeds/${userfeedId}/userfeeds_events`
          : `/api/userfeeds/${userfeedId}/userfeeds_events/${userfeedsEvent.id}`;
        const method = isNew ? axios.post : axios.patch;
        method(endpoint, body)
          .then((response) => {
            loaderRef.current.closeModal();
            if (response.status === 200) {
              setEvent(response.data.userfeeds_event);
              successRef.current.openModal();
            } else {
              errorRef.current.openModal();
            }
          })
          .catch(() => {
            loaderRef.current.closeModal();
            errorRef.current.openModal();
          });
      } catch (error) {
        loaderRef.current.closeModal();
        errorRef.current.openModal();
      }

      setIsProcessing(false);
    },
    [
      loaderRef,
      successRef,
      errorRef,
      eventDate,
      place,
      capacity,
      minNumOfPeople,
      isPayedByAmazon,
      hasCredit,
      isNew,
      userfeedId,
      userfeedsEvent,
      isProcessing,
      point,
    ]
  );

  const handleDeleteEvent = () => {
    loaderRef.current.openModal();
    axios.delete(`/api/userfeeds/${userfeedsEvent.userfeed_id}/userfeeds_events/${userfeedsEvent.id}`)
    .then(() => {
      window && (window.location.href = `/userfeeds/${userfeedsEvent.userfeed_id}/userfeeds_events/${userfeedsEvent.id}/delete_confirm?__back_button=close`);
    })
    .catch(() => {
      loaderRef.current.closeModal();
      errorRef.current.openModal();
    }
    );
  };

  const toEventShowPage = useCallback(() => {
    isPayedByAmazon ? window && (window.location.href = `/userfeeds/${event.userfeed_id}/userfeeds_events/${event.id}?is_payed_by_amazon=true`) :
    window && (window.location.href = `/userfeeds/${event.userfeed_id}/userfeeds_events/${event.id}`);
  });

  return (
    <div>
      <main className="bg-white h-100 pt-3 min-vh-100">
        <div className="container col-md-8 col-lg-6">
          <img src="/images/userfeeds_event_image.png" className="w-100" alt="userfeeds event image" style={{borderRadius: '16px'}} />
          <h1 className="text-fz-18px text-fw-bold text-black-333 mb-2 mt-3 text-center">
            トークルームで仲間を募って<br/>
            お出かけしよう！
          </h1>
          <p className="text-fz-14px text-black-50 mb-2 text-center">
          興味の合う人とお話しして日時や場所を決めよう
          </p>
          <p className="text-fz-14px text-black-50 mb-5 text-center">
            <a href="https://tunagate.com/articles/update/new-service/talkroom-event">この機能の詳しい説明はこちら</a>
          </p>
        </div>
        <div className="container col-md-8 col-lg-6 py-3_5">
          <div className="mb-2 mt-2 d-inline-block">
            <p className="text-fz-14px text-fw-bold text-black-333">日時</p>
            {isEventDateDisabled ? (
              <p className="text-fz-small text-danger mb-2">
                ※集合時刻は変更できません。
              </p>
            ) : (
              <p className="text-fz-small text-black-50 mb-2">
                現在時刻より6時間以上先に設定してください
              </p>
            )}
          </div>

        </div>
        <div className="container col-md-8 col-lg-6 py-3_5">
          <DatePicker
            className="form-control text-right bg-gray border-0"
            wrapperClassName='w-100'
            dateFormat="yyyy/MM/dd HH:mm"
            locale="ja"
            selected={eventDate}
            onChange={date => setEventDate(date)}
            placeholderText="2023/07/07 19:00"
            showTimeSelect
            timeIntervals={10}
            timeCaption="時間"
            minDate={now}
            maxDate={maxDate}
            minTime={
              eventDate &&
              eventDate.getMonth() === now.getMonth() &&
              eventDate.getDate() === now.getDate()
                ? minTime
                : startTime
            }
            maxTime={maxTime}
            disabled={isEventDateDisabled}
          />
        </div>
        <div className="container col-md-8 col-lg-6 py-3_5">
          <p className="text-fz-14px text-fw-bold text-black-333 mb-2 mt-3 d-inline-block">
            集合場所
          </p>
        </div>
        <div className="container col-md-8 col-lg-6 py-3_5">
          <input
            id="place"
            value={place}
            onChange={(e) => setPlace(e.target.value)}
            className="form-control text-right bg-gray border-0"
            placeholder="渋谷駅モヤイ像前"
          />
        </div>
        <div className="container col-md-8 col-lg-6 py-3_5">
          <p className="text-fz-14px text-fw-bold text-black-333 mb-2 mt-3 d-inline-block">
            最小催行人数
          </p>
        </div>
        <div className="container col-md-8 col-lg-6 py-3_5">
          <select
            className="form-control text-right bg-gray border-0"
            name="min_num_of_people"
            id="min_num_of_people"
            onChange={(e) => {
              setMinNumOfPeople(Number(e.target.value))
              if (capacity !== '' && capacity < Number(e.target.value)){
                setCapacity(Number(e.target.value))
              }
            }}
            value={minNumOfPeople}
          >
            {Array.from({length: 8}, (_, i) => i + 2).map((num) => (
              <option key={num} value={num} disabled={capacity !== '' && num > capacity}>{num}</option>
            ))}
          </select>
        </div>
        <div className="container col-md-8 col-lg-6 py-3_5">
          <p className="text-fz-14px text-fw-bold text-black-333 mb-2 mt-3 d-inline-block">
            最大人数
          </p>
        </div>
        <div className="container col-md-8 col-lg-6 py-3_5">
          <select
            className="form-control text-right bg-gray border-0"
            name="capacity"
            id="capacity"
            onChange={(e) => setCapacity(Number(e.target.value))}
            value={capacity}
          >
            <option value={''}>制限なし</option>
            {Array.from({length: 99}, (_, i) => i + 2).map((num) => (
              <option key={num} value={num} disabled={num < minNumOfPeople}>{num}</option>
            ))}
          </select>
        </div>
        {isNew ? (
          isPaidVersion ? (
            <div>
              <div className="container col-md-8 col-lg-6 py-3_5">
                <p className="text-fz-14px text-fw-bold text-black-333 mb-2 mt-3 d-inline-block">
                  料金
                </p>
                <p className="text-fz-14px text-fw-bold text-black-333 mb-2 mt-3 d-inline-block">
                  参加料 200円 + デポジット 700円
                </p>
                <p className="text-fz-14px text-black-50 mb-2 pl-3">
                  イベント当日に、他の参加者と会えたらデポジット700円は返金されます。
                </p>
              </div>
            </div>
          ) : (
            <div className="container col-md-8 col-lg-6 py-3_5">
            <p className="text-fz-14px text-fw-bold text-black-333 mb-2 mt-3 d-inline-block">
              料金
            </p>
            <p className="text-fz-14px text-fw-bold text-black-333 mb-2 mt-3 d-inline-block">
              　無料
            </p>
          </div>
          )
        ) : (
          // 現在時刻がイベント開始時刻30分前を過ぎていたら、イベントを中止するボタンを表示しない
          !eventDate || (eventDate && now.getTime() < eventDate.getTime() - 30 * 60 * 1000) ? (
            <div className="container col-md-8 col-lg-6 p-3_5 pt-5">
              <a className="w-100 cursor-pointer" onClick={handleDeleteEvent}>
                <p className="text-primary text-center mb-0">このイベントを中止する</p>
              </a>
            </div>
          ) : (
            <div className="container col-md-8 col-lg-6 p-3_5 pt-5">
              <p className="text-muted text-center mb-0">イベントは現在中止できません。中止はイベント開始30分前まで可能です。</p>
            </div>
          )
        )}
        <div className={`container col-md-8 col-lg-6 mt-2 mb-5 pb-5 ${isNew && 'pt-5'}`}>
          {isNew && isPaidVersion && (
            <div className="custom-control custom-switch custom-switch-md text-center w-100 mb-3">
              <input
                type="checkbox" className="custom-control-input" id="is_payed_by_amazon"
                defaultChecked={isPayedByAmazon}
                onChange={(e) => setIsPayedByAmazon(e.target.checked)}
              />
              <label className="custom-control-label" htmlFor="is_payed_by_amazon">
                Amazon Payで決済する
              </label>
            </div>
          )}
          <button
            type="button"
            className="col-6 a-button a-button__top bg-tunagate-gradation text-white w-100"
            onClick={(e) => onSubmit(e)}
            disabled={place === '' || capacity !== '' && minNumOfPeople > capacity || eventDate === ''}
          >
            {isNew ? (isPaidVersion ? '参加決済して募集する' : '募集する') : '更新する'}
          </button>
        </div>
      </main>
      <ModalAlert
        ref={successRef}
        name={`送信完了`}
        content={`${isNew ? (isPayedByAmazon ? '決済画面に移動します。（決済完了と同時にイベントが作成されます）' : '作成しました。') : '更新しました。'}`}
        approveFunc={toEventShowPage}
      />
      <ModalAlert
        ref={errorRef}
        name={`送信失敗`}
        content="失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} />
      <ModalAlert
        ref={modalAlertCreditErr}
        title="クレジットカード登録"
        approveFunc={() => modalCreditcardRef.current.openModal()}
        content="クレジットカードが必要です。"
      />
      <ModalRegisterCreditcard
        successFunc={() => {
          setHasCredit(true);
          window.location.reload();
        }}
        cardEmail={cardEmail}
        ref={modalCreditcardRef}
      />
    </div>
  );
};

export default Edit;
